<template>
  <transition name="slide-down">
    <div
      v-if="isIncommingCall || isOutgoingCall"
      class="call-notification-overlay"
    >
      <div
        class="call_action_container"
        :class="{ collapse: !isExpand, absolute_container: isCollapsible }"
      >
        <button v-if="isShowCloseBtn" class="close-button" @click="closeCall">
          <fluent-icon icon="dismiss" size="16" />
        </button>
        <!-- Incoming Call -->
        <section v-if="isIncommingCall" class="call_container">
          <div>
            <p class="Xparagraph Xparagraph--black">
              {{ callStatusText
              }}<b class="sub-block-title">{{
                twilioCall.contact.name || twilioCall.contact.phone_number
              }}</b>
            </p>
          </div>
          <div v-if="isCallOnProcess" class="call_duration">
            <h1>{{ formattedCallDuration }}</h1>
          </div>
          <div>
            <woot-button
              v-if="showAcceptBtn"
              v-tooltip="$t('CONTACT_PANEL.MUTE_CONTACT')"
              variant="smooth"
              color-scheme="success"
              size="small"
              @click="acceptIncomingCall"
            >
              {{ $t('CONTACT_PANEL.CALL.BTNS.ACCEPT') }}
            </woot-button>
            <woot-button
              v-if="showAcceptBtn"
              v-tooltip="$t('CONTACT_PANEL.MUTE_CONTACT')"
              variant="smooth"
              color-scheme="alert"
              size="small"
              @click="rejectIncomingCall"
            >
              {{ $t('CONTACT_PANEL.CALL.BTNS.REJECT') }}
            </woot-button>
            <woot-button
              v-if="!isCallOnProcess"
              v-tooltip="$t('CONTACT_PANEL.MUTE_CONTACT')"
              variant="smooth"
              color-scheme="success"
              size="small"
              @click="redialCall"
            >
              {{ $t('CONTACT_PANEL.CALL.BTNS.REDIAL') }}
            </woot-button>
            <!-- need end button  -->
            <woot-button
              v-if="!showAcceptBtn && isCallOnProcess"
              v-tooltip="$t('CONTACT_PANEL.MUTE_CONTACT')"
              variant="smooth"
              color-scheme="alert"
              size="small"
              @click="endCurrentCall"
            >
              {{ $t('CONTACT_PANEL.CALL.BTNS.END') }}
            </woot-button>
          </div>
          <div
            v-if="
              callCurrentStatus === 'ended' || callCurrentStatus === 'error'
            "
            class="status_box"
          >
            <MultiselectDropdown :label="'Determine the call outcome'">
              <select
                id="status"
                v-model="selectedStatus"
                class="paragraph paragraph--black"
                @change="onStatusChange"
              >
                <option disabled value="">{{
                  $t('CONTACT_PANEL.CALL.EVALUATION.PLACEHOLDER')
                }}</option>
                <option
                  v-for="status in statusList"
                  :key="status.id"
                  :value="status.id"
                  class="paragraph paragraph--black"
                >
                  {{ status.title }}
                </option>
              </select>
            </MultiselectDropdown>
          </div>
        </section>

        <!-- outgoing call -->
        <section v-if="isOutgoingCall" class="call_container">
          <div>
            <p class="Xparagraph Xparagraph--black">
              {{ callStatusText }}
              <b class="sub-block-title">
                {{ twilioCall.contact.name || twilioCall.contact.phone_number }}
              </b>
            </p>
          </div>
          <div v-if="isCallOnProcess" class="call_duration">
            <h1>{{ formattedCallDuration }}</h1>
          </div>
          <div>
            <woot-button
              v-if="isCallOnProcess"
              v-tooltip="$t('CONTACT_PANEL.MUTE_CONTACT')"
              variant="smooth"
              color-scheme="alert"
              size="small"
              @click="endCurrentCall"
            >
              {{ $t('CONTACT_PANEL.CALL.BTNS.END') }}
            </woot-button>
            <woot-button
              v-if="!isCallOnProcess"
              v-tooltip="$t('CONTACT_PANEL.MUTE_CONTACT')"
              variant="smooth"
              color-scheme="success"
              size="small"
              @click="redialCall"
            >
              {{ $t('CONTACT_PANEL.CALL.BTNS.REDIAL') }}
            </woot-button>
          </div>
          <div
            v-if="
              callCurrentStatus === 'ended' || callCurrentStatus === 'error'
            "
            class="status_box"
          >
            <MultiselectDropdown :label="'Determine the call outcome'">
              <select
                id="status"
                v-model="selectedStatus"
                class="paragraph paragraph--black"
                @change="onStatusChange"
              >
                <option disabled value="">
                  {{ $t('CONTACT_PANEL.CALL.EVALUATION.PLACEHOLDER') }}
                </option>
                <option
                  v-for="status in statusList"
                  :key="status.id"
                  :value="status.id"
                  class="paragraph paragraph--black"
                >
                  {{ status.title }}
                </option>
              </select>
            </MultiselectDropdown>
          </div>
        </section>

        <woot-button
          v-if="isCollapsible"
          variant="smooth"
          size="small"
          color-scheme="secondary"
          class="callCard-toggle"
          :icon="isUporDownIcon"
          @click="onToggleCallCard"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import twilioCallMixin from 'shared/mixins/twilioCallMixin.js';
import MultiselectDropdown from 'components/ui/inputs/MultiselectDropdown.vue';
import { CALL_LOCAL_STATUS } from 'dashboard/helper/twilio_sdk.js';
import alertMixin from 'shared/mixins/alertMixin';
import VoiceAPI from 'dashboard/api/voice.js';
import { CALL_TWILIO_EVALUATION } from 'dashboard/routes/dashboard/settings/campaigns/broadcastAgent/aiCampaignConstant.js';
import moment from 'moment';

export default {
  components: {
    MultiselectDropdown,
  },
  mixins: [twilioCallMixin, alertMixin],
  props: {
    contact: {
      type: Object,
      default: () => ({}),
    },
    isCollapsible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isExpand: true,
      selectedStatus: '',
    };
  },
  computed: {
    ...mapGetters({
      twilioCall: 'contactConversations/getTwilioCall',
      twilioCallDuration: 'contactConversations/getCallDuration',
      currentUser: 'getCurrentUser',
    }),
    isUporDownIcon() {
      return this.isExpand ? 'chevron-up' : 'chevron-down';
    },
    statusList() {
      return CALL_TWILIO_EVALUATION.map(el => ({
        ...el,
        title: this.$t(el.title),
      }));
    },
    isOutgoingCall() {
      return this.twilioCall?.callParams?.direction === 'outgoing';
    },
    isIncommingCall() {
      // return true
      return this.twilioCall?.callParams?.direction === 'incomming';
    },
    showAcceptBtn() {
      if (this.twilioCall?.callStatus === 'started') {
        return true;
      }
      return false;
    },
    isCallOnProcess() {
      if (this.twilioCall?.callStatus === 'started') {
        return true;
      }
      if (this.twilioCall?.callStatus === 'in_process') {
        return true;
      }
      return false;
    },
    callCurrentStatus() {
      return this.twilioCall?.callStatus;
    },
    callStatusText() {
      let statusText = '';
      switch (this.twilioCall?.callStatus) {
        case CALL_LOCAL_STATUS.started:
          statusText = this.isOutgoingCall
            ? this.$t('CONTACT_PANEL.CALL.CALL_LABEL.DIALING')
            : this.$t('CONTACT_PANEL.CALL.CALL_LABEL.INCOMING_FORM');
          break;
        case CALL_LOCAL_STATUS.in_process:
          statusText = this.isOutgoingCall
            ? this.$t('CONTACT_PANEL.CALL.CALL_LABEL.OUT_TO')
            : this.$t('CONTACT_PANEL.CALL.CALL_LABEL.IN_CALL');
          break;
        case CALL_LOCAL_STATUS.ended:
          statusText = this.isOutgoingCall
            ? this.$t('CONTACT_PANEL.CALL.CALL_LABEL.END_CALL')
            : this.$t('CONTACT_PANEL.CALL.CALL_LABEL.END_CALL');
          break;
        case CALL_LOCAL_STATUS.error:
          statusText = this.isOutgoingCall
            ? this.$t('CONTACT_PANEL.CALL.CALL_LABEL.ERROR_CALL')
            : this.$t('CONTACT_PANEL.CALL.CALL_LABEL.ERROR_CALL');
          break;

        default:
          break;
      }
      return statusText;
    },
    formattedCallDuration() {
      const duration = moment.duration(this.twilioCallDuration, 'seconds'); // convert seconds to duration
      const hours = Math.floor(duration.asHours());
      const minutes = duration.minutes();
      const seconds = duration.seconds();

      if (hours > 0) {
        // show HH:MM:SS
        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
          2,
          '0'
        )}:${String(seconds).padStart(2, '0')}`;
      }

      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(
        2,
        '0'
      )}`;
    },
    isShowCloseBtn() {
      // Show close button for terminal states
      return (
        this.callCurrentStatus === 'ended' || this.callCurrentStatus === 'error'
      );
    },
  },
  methods: {
    async acceptIncomingCall() {
      // accept incomming call
      // navigate to contact page
      const { isAccepted } = await this.onIncommingCallAccept();
      if (isAccepted) {
        console.log(this.twilioCall);
        // this.$router.push(`/app/accounts/${this.currentUser.account_id}/contacts/${this.twilioCall?.callParams?.contact_id}`);
        // const {data} = await ContactsAPI.search(this.twilioCall?.callParams?.phone_number);
        // console.log("Contacts ",data);
        // if (data?.payload) {
        //     const callerContact = data.payload.find(el=>el.phone_number === this.twilioCall?.callParams?.phone_number);
        //     if (callerContact) {
        //         this.$router.push(`/app/accounts/${this.currentUser.account_id}/contacts/${callerContact.id}`);
        //     }
        // }
      }
    },
    endCurrentCall() {
      // this.$store.dispatch('contactConversations/endCall');
      this.endCall();
    },
    rejectIncomingCall() {
      this.onIncommingCallCancel();
    },
    async redialCall() {
      if (this.twilioCall?.callParams) {
        await this.makeTwioloCall({
          To: this.twilioCall.contact.phone_number,
          account_id: this.currentUser.account_id,
          name: this.twilioCall.contact.name || '',
        });
      }
    },
    closeCall() {
      this.$store.dispatch('contactConversations/clearTwilioCall');
    },
    onToggleCallCard() {
      this.isExpand = !this.isExpand;
    },
    async onStatusChange() {
      console.log(
        'status',
        this.selectedStatus,
        this.twilioCall,
        this.twilioCall.callInstance?.parameters
      );
      try {
        // this.twilioCall?.parameters?.CallSid
        const payload = {
          call_sid: this.twilioCall?.callInstance?.parameters?.CallSid || null,
          evaluation: this.selectedStatus,
        };

        await VoiceAPI.call_evaluation(payload);
        // clear the selected state
        this.selectedStatus = '';
        this.closeCall();
      } catch (error) {
        this.selectedStatus = '';
        this.showErrAlert(
          error,
          this.$t('CAMPAIGN.CAMPAIGN_FORMS.ADD.ACTIONS.FAIL')
        );
        // clear the selected state
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '~dashboard/assets/scss/variables';
@import '~dashboard/assets/scss/mixins';

// local SCSS variables
$collapse_height: 34px;

.call-notification-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  pointer-events: none;
}

.absolute_container {
  max-width: 90vw;
}

.call_action_container {
  position: relative;
  margin-top: 16px;
  max-width: 500px;
  width: 90%;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2), 0 2px 8px rgba(0, 0, 0, 0.1);
  pointer-events: auto;
  overflow: hidden;
  padding: $space-normal;
  padding-bottom: $collapse_height;
  transition: height 0.3s ease;

  &.collapse {
    height: $collapse_height;
  }
}

.close-button {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 32px;
  height: 32px;
  background: white;
  border: 1px solid var(--s-200);
  cursor: pointer;
  padding: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  color: var(--s-700);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 10;

  &:hover {
    background-color: var(--s-50);
    color: var(--s-900);
    border-color: var(--s-300);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    transform: scale(1.05);
  }

  &:active {
    background-color: var(--s-100);
    transform: scale(0.95);
  }
}

.call_container {
  text-align: center;
}

.callCard-toggle {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 10;
}

.status_box {
  max-width: 200px;
  margin: 20px auto 0 auto;
}

// Slide down animation
.slide-down-enter-active {
  animation: slideDown 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-down-leave-active {
  animation: slideUp 0.3s cubic-bezier(0.4, 0, 0.6, 1);
}

@keyframes slideDown {
  from {
    transform: translateY(-120%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(-120%);
    opacity: 0;
  }
}
</style>
